<template>
  <span>
    <span class="ui-text-clickable" @click="isDialogOpen = true"
      ><slot>Add New</slot></span
    >
    <hi-dialog
      v-model="isDialogOpen"
      title="Create New Group Mail"
      @submit="submit"
      :submit-disabled="!name || !name.length"
      :error="error"
    >
      <v-text-field
        v-model="name"
        label="Group Mail Name"
        ref="input"
      ></v-text-field>
    </hi-dialog>
  </span>
</template>

<script>
import HiDialog from "@/components/HiDialog";
import { DocHelper } from "@/db";
export default {
  name: "DiNewGroupMail",
  components: { HiDialog },
  data() {
    return {
      isDialogOpen: false,
      name: null,
      error: null
    };
  },
  methods: {
    async submit() {
      try {
        await DocHelper.newDoc("emails/data/groupMails", {
          name: this.name
        });
        this.isDialogOpen = false;
      } catch (e) {
        this.error = e.message;
      }
    }
  }
};
</script>

<style scoped></style>
